
import {
  Texture,
  ShaderMaterial,
  NormalBlending
} from "three";

export function getXRShadowMaterial(map:Texture):ShaderMaterial {
  const material = new ShaderMaterial({
    uniforms: {
      u_map: {
        value: map
      }
    },
    vertexShader: `
varying vec2 v_uv;

void main() {
  v_uv = uv;
  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
}
    `,
    fragmentShader: `
varying vec2 v_uv;

uniform sampler2D u_map;

void main() {
  float shadow = texture2D(u_map, v_uv).r;

  shadow *= shadow * shadow;

  gl_FragColor = vec4(vec3(0.0), 1.0 - shadow);
}
`,
    blending: NormalBlending,
    transparent: true
  });

  (<any>material).isXRShadowMaterial = true;

  return material;
}